import React, { useState, useRef } from 'react'
import { selectFontStyle } from '../../../../../CommonComponent/SelectFontStyle'
import { useOnClickOutside } from '../../../../../CommonComponent/outsideClick'

export default function LotListingHeader({auctionData, totalLots = 0, onSortChange, onSearchChange}) {
    const [isSortOpen, setIsSortOpen] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    
    const filterRef = useRef();
    const sortRef = useRef();
    
    useOnClickOutside(filterRef, () => setIsFilterOpen(false));
    useOnClickOutside(sortRef, () => setIsSortOpen(false));

    return (
        <div className="sm:mt-10 mt-3 flex justify-between flex-wrap items-center">
            <p className="text-[16px] leading-normal font-medium text-[#343434]" 
                style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                    color: auctionData.content_area['text_color']
                }} > <span>{totalLots} </span> lots</p>
            <div className="flex ml-auto  flex-wrap items-center">
                {/* <!-- search  --> */}
                <div className="relative pr-3 py-[12px]">
                    <input autoComplete='off' type="text" 
                        onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
                        className="text-[14px] relative w-[270px] 
                            h-[32px] pl-8 pr-3  bg-[#fff] border border-[#A1A1A9] placeholder:text-[#A1A1A9] 
                            focus:border-[#343434] outline-none font-medium leading-normal text-[#4A4A4A]" placeholder="Search" />
                    <img src="/images/search-icon-large.svg" alt="search-icon" 
                        className="absolute top-5 cursor-default left-2.5" loading="lazy" />
                </div>
                {/* <!-- filter --> */}
                <div className="relative mr-2.5 cursor-default" ref={filterRef}>
                    <button id="filter" 
                        onClick={() => { setIsFilterOpen(!isFilterOpen); setIsSortOpen(false); }}
                        className="text-[14px] cursor-pointer hover:bg-[#F4F4F5] transition-colors relative text-[#52525A] 
                            border h-[32px] border-[#A1A1A9] rounded-[6px] leading-normal
                            font-medium pr-[20px] pl-[36px]" style={{fontFamily: selectFontStyle(auctionData.font['body_font'])}}>
                        Filter
                    </button>
                    <img src="/images/filter-icon.svg" alt="filter-icon" 
                        className="absolute top-[10px] left-2.5 pointer-events-none" 
                        loading="lazy" />
                    {isFilterOpen && (
                        <div className="absolute right-0 mt-1 w-48 bg-white border border-[#D4D4D8] 
                            rounded-md shadow-lg z-20 p-3">
                            <p className="text-[12px] text-[#A1A1A9] italic text-center">Filter options would appear here</p>
                        </div>
                    )}
                </div>
                {/* <!-- sort button --> */}
                <div className="relative cursor-pointer" ref={sortRef}>
                    <button id="sort" type="button" 
                        onClick={() => { setIsSortOpen(!isSortOpen); setIsFilterOpen(false); }}
                        className="text-[14px] cursor-pointer hover:bg-[#F4F4F5] transition-colors text-[#52525A] 
                            border w-[80px] h-[32px] border-[#A1A1A9] rounded-[6px] leading-normal font-medium 
                            pr-[5px] pl-[34px]" style={{fontFamily: selectFontStyle(auctionData.font['body_font'])}}>
                        Sort
                    </button>
                    <img src="/images/export-icon.svg" alt="export-icon" 
                        className="absolute top-[7px] left-2.5 pointer-events-none" loading="lazy" />
                    {isSortOpen && (
                        <div className="absolute right-0 mt-1 w-48 bg-white border border-[#D4D4D8] 
                            rounded-md shadow-lg z-20 py-1">
                            <p className="text-[14px] px-4 py-2 hover:bg-[#F4F4F5] cursor-pointer text-[#343434]" 
                                onClick={() => { onSortChange && onSortChange('lot_number'); setIsSortOpen(false); }}>
                                Lot number</p>
                            <p className="text-[14px] px-4 py-2 hover:bg-[#F4F4F5] cursor-pointer text-[#343434]" 
                                onClick={() => { onSortChange && onSortChange('price_low'); setIsSortOpen(false); }}>
                                Price (Low to High)</p>
                            <p className="text-[14px] px-4 py-2 hover:bg-[#F4F4F5] cursor-pointer text-[#343434]" 
                                onClick={() => { onSortChange && onSortChange('price_high'); setIsSortOpen(false); }}>
                                Price (High to Low)</p>
                        </div>
                    )}
                </div>
            </div>
        </div>    
    )
}
